export const fetchSEOSchema = async url => {
  try {
    const response = await fetch(url);

    // Check if the response is successful
    if (!response.ok) {
      throw new Error(
        `Failed to fetch schema: ${response.status} ${response.statusText}`
      );
    }
    // Parse JSON data
    const schema = await response.json();
    console.log('Fetched Schema:', schema);
    return schema;
  } catch (error) {
    console.error('Error fetching schema:', error.message);
    return null;
  }
};

export const populateSchema = (template, data) => {
  const resolvePath = (path, obj) => {
    return path.split(/\.|\[|\]/).reduce((acc, key) => {
      if (!key) return acc; // Skip empty keys (e.g., from split by `.` or `[`)
      return acc && acc[key] !== undefined ? acc[key] : ''; // Return value or empty string
    }, obj);
  };

  const replacePlaceholders = (obj, values) => {
    if (typeof obj === 'string') {
      return obj.replace(/{{(.*?)}}/g, (_, key) =>
        resolvePath(key.trim(), values)
      );
    } else if (Array.isArray(obj)) {
      return obj.map(item => replacePlaceholders(item, values));
    } else if (typeof obj === 'object' && obj !== null) {
      return Object.keys(obj).reduce((acc, key) => {
        acc[key] = replacePlaceholders(obj[key], values);
        return acc;
      }, {});
    }
    return obj;
  };
  return replacePlaceholders(template, data);
};
